import React from "react";
import { Modal, Text, TouchableOpacity, View } from "react-native";
import style from "./style";
import PremiMultimedia from "../Premi/PremiMultimedia";

//todo introduir traduccións al nom del premi
function PopUpPerfilImatge(premi, modalVisible, setModalVisible) {
  return (
    <TouchableOpacity
      onPress={() => {
        setModalVisible(false);
      }}
    >
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onBackdropPress={() => setModalVisible(false)}
      >
        <View style={style.modalOutBackground}>
          <View style={{ display: "flex", height: "60%", width: "80%" }}>
            {PremiMultimedia(premi)}
            <Text style={style.textPerfil}>{premi.Nom}</Text>
          </View>
        </View>
      </Modal>
    </TouchableOpacity>
  );
}

export default PopUpPerfilImatge;
